import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lhgl",
  "use": "icon-lhgl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-lhgl\"><defs><style type=\"text/css\"></style></defs><path d=\"M467.2 681.6v-128c-124.8-19.2-217.6-128-217.6-256 0-48 12.8-92.8 38.4-131.2l128 128L512 192l96 102.4 128-131.2c22.4 38.4 38.4 83.2 38.4 131.2 0 128-92.8 236.8-217.6 256v128c51.2-86.4 172.8-163.2 304-118.4 0 0-115.2 297.6-348.8 297.6-230.4 0-348.8-297.6-348.8-297.6 134.4-41.6 252.8 35.2 304 121.6z\" p-id=\"4621\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol